import script from "./InstructionNovaTalksPage.vue?vue&type=script&setup=true&lang=js"
export * from "./InstructionNovaTalksPage.vue?vue&type=script&setup=true&lang=js"

import "./InstructionNovaTalksPage.vue?vue&type=style&index=0&id=b6591f1e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b6591f1e"]])

export default __exports__